<template>
  <span class="bookmark" :class="{checked: bookmarked}">
    <i class="icon-progress" v-if="loading"></i>
    <i class="icon-fav-empty" v-else-if="!bookmarked" @click="addBookmark"/>
    <i class="icon-fav-empty" v-else @click="removeBookmark"/>
  </span>
</template>

<script>
import api from '@/api/bookmark';
export default {
name: "Bookmark",
props: ['contentId'],
data() {
  return {
    loading: false,
    bookmarkedNow: undefined,
  }
},
computed: {
  bookmark() {
    return this.$store.getters.bookmarkByContentID(this.contentId)
  },
  bookmarked() {
    if(this.bookmarkedNow !== undefined) {
      return this.bookmarkedNow
    }
    return !!this.bookmark;
  }
},
methods: {
  addBookmark() {
    this.bookmarkedNow = this.bookmarked
    this.loading = true
    api.addBookmark({
      idContent: this.contentId,
      idUser: this.$store.getters.user.idUser
    }, () => {
      this.loading = false
      this.bookmarkedNow = true;
      this.$store.dispatch('getUserInfo', this.$store.getters.selectedCompanyId)
    })
  },
  removeBookmark() {
    this.bookmarkedNow = this.bookmarked
    this.loading = true
    api.removeBookmark(this.bookmark.idUserBookmarkContent, () => {
      this.bookmarkedNow = false;
      this.loading = false
      this.$store.dispatch('getUserInfo', this.$store.getters.selectedCompanyId)
    })
  }
}
}
</script>

<style scoped>

</style>